import React from "react";
import "./NavBar.css";
import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import LoggedInNavbar from "./LoggedInNavbar";
import LoggedOutNavbar from "./LoggedOutNavbar";
import FlexiRegistrationNavbar from "./FlexiRegistrationNavbar";
// type for antd

const { Header } = Layout;

function NavBar(props: any) {
  const { isLoggedIn, logOut } = props;
  const location = useLocation();
  const pathname: string = location.pathname.split("/")[1];

  if (pathname === "flexi-registration" || pathname === "return_url") {
    return (
      <Header className="logo-only">
        <FlexiRegistrationNavbar />
      </Header>
    );
  }
  if (pathname === "meeting") {
    return null;
  }
  if (isLoggedIn)
    return (
      <Header className="logged-in-navbar">
        <LoggedInNavbar logOut={logOut} />
      </Header>
    );
  return (
    <Header className="logged-out-navbar">
      <LoggedOutNavbar />
    </Header>
  );
}
export default NavBar;
